import { Control, Controller, FieldPath, FieldValues } from "react-hook-form";
import { SelectInputBox, SelectInputBoxProps } from "component-library";
import { PropsWithChildren } from "react";

type ControlledSelectInputBoxProps<
  T,
  F extends FieldValues,
  N,
> = PropsWithChildren<
  {
    control: Control<F>;
    name: N;
    required?: string;
  } & Omit<SelectInputBoxProps<T>, "value" | "onChange">
>;

export const ControlledSelectInputBox = <
  SelectType,
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: ControlledSelectInputBoxProps<SelectType, TFieldValues, TName>,
) => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      rules={{ required: props.required }}
      render={({ field, fieldState }) => (
        <SelectInputBox
          isMultiSelect={props.isMultiSelect}
          value={field.value}
          onChange={field.onChange}
          error={fieldState.error?.message}
        >
          {props.children}
        </SelectInputBox>
      )}
    />
  );
};
